<template>
    <div
        class="assignments"
        v-if="portfolio">
        <div class="row">
            <div
                class="col-12 col-md-4 col-lg-3 left-side"
                v-if="portfolio.categories.length">
                <b-nav
                    class="assignments-categories"
                    vertical
                    pills>
                    <b-nav-item
                        class="assignment-category"
                        v-for="(category, catIndex) in portfolio.categories"
                        :key="catIndex"
                        @click="selectCategory(category)"
                        active-class="active"
                        :active="selectedCategory.id === category.id">
                        {{ category.name }}
                    </b-nav-item>
                </b-nav>
            </div>

            <div class="col-12 col-md-8 col-lg-9 right-side">
                <div
                    class="category-assignments apprentice-simple-card"
                    v-if="selectedCategory && selectedCategoryAssignments.length">
                    <div
                        class="component-title"
                        v-if="selectedCategoryAssignments.length">
                        <h5 class="title">{{ selectedCategory.name }}</h5>
                        <div class="tools">
                            <b-badge
                                class="badge-rating"
                                v-if="hasRatingResult(selectedCategory)"
                                pill
                                variant="primary">
                                <i class="fas fa-fw fa-trophy"></i>{{ getResultValue(selectedCategory) }}
                            </b-badge>

                            <b-button
                                class="btn-medal btn-rate-category"
                                v-b-tooltip.hover
                                v-if="canRate(selectedCategory)"
                                v-b-modal="'category-rating-' + selectedCategory.id"
                                variant="primary-icon"
                                :title="$t('internship.rating')"
                                data-toggle="tooltip"
                                data-placement="bottom">
                            </b-button>
                            <design-2021-portfolio-show-rating-modal-component
                                v-if="canRate(selectedCategory)"
                                :rating-in="selectedCategory.portfolio_rating"
                                :key-name="'category-rating-' + selectedCategory.id"
                                :children-in="selectedCategory.assignments"
                                :child-title="$t('internship.exercise_results')"
                                :title="$t('internship.category_assessment') + selectedCategory.name"
                                @save-rating="savePortfolioRating($event, selectedCategory)">
                            </design-2021-portfolio-show-rating-modal-component>
                        </div>
                    </div>
                    <div class="assignments">
                        <design-2021-portfolio-show-assignments-card-component
                            :items="selectedCategoryAssignments"
                            :project-id="projectIn.id">
                        </design-2021-portfolio-show-assignments-card-component>
                    </div>
                </div>

                <div
                    class="category-assignments apprentice-simple-card"
                    v-else>
                    <div class="not-found with-header empty-assignments-list">
                        <div class="icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-notice">{{ $t('internship.no_assignments_ready_yet') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internship-report-show-assignments-component',
    props: ['portfolioIn', 'projectIn', 'categoryId'],
    data() {
        return {
            portfolio: this.portfolioIn,
            activeTab: 0,
            selectedCategory: {},
        };
    },
    computed: {
        selectedCategoryAssignments() {
            let categories = [];
            if (this.selectedCategory && this.portfolio) {
                for (const [catIndex, category] of this.portfolio.categories.entries()) {
                    if (category.id === this.selectedCategory.id) {
                        categories = category.assignments.map((assignment) => {
                            return {
                                category: category.name,
                                name: assignment.name,
                                id: assignment.id,
                                portfolio_rating: assignment.portfolio_rating,
                                progress_status: assignment.progress_status,
                                deadline: assignment.deadlines.length >= 1 ? assignment.deadlines[0].agenda_item : null,
                            };
                        });
                    }
                }
            }
            return categories;
        },
    },

    methods: {
        updateTabIndex(tabIndex) {
            const name = 'portfolio-show-' + this.portfolioIn.id;
            this.activeTab = tabIndex;
            localStorage.setItem(name, tabIndex);
        },
        canRate(category) {
            return !this.$authUser.isStudent() && category.portfolio_rating && category.portfolio_rating.type;
        },
        hasRatingResult(category) {
            return category.portfolio_rating && category.portfolio_rating.results.length;
        },
        getResultValue(category) {
            if (!category.portfolio_rating || !category.portfolio_rating.results.length) {
                return null;
            }

            if (category.portfolio_rating.type === 1) {
                const id = category.portfolio_rating.results[0].portfolio_rating_option_id;
                for (const option of category.portfolio_rating.options) {
                    if (option.id === id) {
                        return option.value;
                    }
                }
            }

            if (category.portfolio_rating.type === 2) {
                return category.portfolio_rating.results[0].value;
            }

            return null;
        },
        savePortfolioRating(values, category) {
            if (!values.rating.value && !values.rating.option_id && !category.portfolio_rating.results.length) {
                return;
            }

            this.alert.saving();

            let data = values.rating;

            data.project_id = this.projectId;

            if (!category.portfolio_rating.results.length) {
                this.axios.post(this.routes.portfolioRatingResult(), data).then(
                    (response) => {
                        category.portfolio_rating.results = [response.data];
                        this.alert.success();
                        // this.fireClose(); todo
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.axios.post(this.routes.portfolioRatingResultUpdate(), data).then(
                    (response) => {
                        if (response.data) {
                            category.portfolio_rating.results = [response.data];
                        } else {
                            category.portfolio_rating.results = [];
                        }
                        this.alert.success();
                        // if (!this.assignment.statuses || !this.assignment.statuses.length || this.assignment.statuses[0].status !== 1) {
                        //     this.fireClose();
                        // } else {
                        //     this.alert.success();
                        // } todo
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
        selectCategory(category) {
            const name = 'portfolio-show-' + this.portfolioIn.id + '-selectedCategory';
            this.selectedCategory = category;
            localStorage.setItem(name, category.id);
        },
    },
    mounted() {
        const name = 'portfolio-show-' + this.portfolioIn.id;
        if (this.categoryId) {
            let count = 0;
            for (const category of this.portfolioIn.categories) {
                if (category.id === this.categoryId) {
                    this.activeTab = count;
                    localStorage.setItem(name, count);
                    break;
                }
                count++;
            }
        } else {
            if (localStorage.getItem(name)) {
                this.activeTab = parseInt(localStorage.getItem(name));
            }
        }

        const category = 'portfolio-show-' + this.portfolioIn.id + '-selectedCategory';
        if (localStorage.getItem(category)) {
            for (const [catIndex, portfolioCategory] of this.portfolio.categories.entries()) {
                if (portfolioCategory.id === parseInt(localStorage.getItem(category))) {
                    this.selectedCategory = this.portfolio.categories[catIndex];
                }
            }
        } else {
            this.selectedCategory = this.portfolioIn.categories[0];
        }
    },
};
</script>

<style scoped lang="scss">
.left-side {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.assignments ::v-deep {
    .component-title {
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
        border-bottom: 3px dotted $border-color;
        padding-bottom: map-get($grid-gutter-spacing, 'ten');
    }

    .tools {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .badge-rating {
        font-size: 1.125rem;
        padding-top: map-get($grid-gutter-spacing, 'eight');
        padding-bottom: map-get($grid-gutter-spacing, 'eight');
        height: 37px;

        i {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .btn-rate-category {
        font-size: 1.125rem;
        margin-left: map-get($grid-gutter-spacing, 'fifteen');
        height: 37px;

        &:before {
            margin-right: 0;
        }
    }

    .assignments-categories {
        .nav-item {
            &:not(:last-child) {
                padding-bottom: map-get($grid-gutter-spacing, 'fifteen');
                margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
                border-bottom: 3px dotted $border-color;
            }
        }

        .nav-link {
            color: $text-color;
            padding: map-get($grid-gutter-spacing, 'fifteen');
            background-color: transparent;
            border-radius: $border-radius-content;

            &:hover,
            &.active {
                font-weight: $font-weight-bold;
                background-color: $white;
            }
        }
    }
}

.assignments ::v-deep {
    .assignments-in-progress {
        padding: 0;

        .component-title {
            display: none;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .left-side {
        margin-bottom: 0;
    }
}
</style>
